import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";


import SnowzoneComponent from "../components/Snowzone";
import {
  StyledContent,
  StyledElement,
  StyledSelectWrapper,
  StyledWrapper,
} from "../styles/styledComponents";
import LangParam from "../types/LangParam";
import { useSelectedContextState } from "../context/selectedContext";
import i18n from "../i18n";
import { useTranslation } from "react-i18next";

import { Element } from "react-scroll";

type SnowzoneProps = {
    setParentLanguage: (value: any) => any;
    theme?: any;
  };
const Snowzone = (props: SnowzoneProps) => {
    let { languageId }: LangParam = useParams();
    let { setParentLanguage, theme } = props;
    const { t } = useTranslation("trans");

    useEffect(() => {
        i18n.changeLanguage(languageId);
      }, [languageId]);
    
      useEffect(() => {
        setParentLanguage(languageId);
        document.title = t("application.title");
      }, [languageId, setParentLanguage]);
  return (
    
    <StyledWrapper lang={languageId}>   
    <StyledContent>
        <Element name="snowzone" className="snowzone-container">
        <SnowzoneComponent countryCode={languageId}></SnowzoneComponent>
        </Element>
        </StyledContent>
    </StyledWrapper>
  );
};

export default Snowzone;
